import React from "react";
import { BankOutlined } from "@ant-design/icons";
import { CompanyCardData } from "./types";
import { SectionBlock, MetricTile } from "./shared";

interface Props {
  data: Pick<CompanyCardData, "business_model_text" | "business_model_metrics">;
}

const BusinessModel: React.FC<Props> = ({ data }) => (
  <SectionBlock
    icon={<BankOutlined />}
    title="How the company makes money"
    subtitle="The business model, in plain terms"
  >
    <div className="grid grid-cols-3 gap-3 mt-4 sm:grid-cols-2">
      {data.business_model_metrics.map((tile, i) => (
        <MetricTile key={i} tile={tile} />
      ))}
    </div>
  </SectionBlock>
);

export default BusinessModel;
